import React from "react";
import { Card } from "antd";
import moment from "moment";
import styles from "./tripDetails.module.scss";
import { getTimelineStations } from "../busTimeline";
// import LoungePass from "../loungePass";

const dateFormat = "hh:mm A";
const dayFormat = "MMM DD";
const tierDayFormat = "DD MMM";

const MAXX_LOGO =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/maxIcon_1789012606064.svg";
const PLUS_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/plus_1789015517013.svg";
const BOARDED_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/boardedIcon_1790565067219.svg";
const COMPLETED_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/completedBooking_1789464453783.svg";
const NOT_BOARDED_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/notBoardedIcon_1789013851512.svg";
const ELECTRIC_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/test/selfHelp/electricIcon_1789012477130.svg";
const ARROW_FORWARD =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/arrow-forward.svg";

const TripDetails = props => {
  const { booking, serviceTier, tripStatus, busRoute } = props;
  // Non Stop when none of the stations shown in the timeline is a rest stop.
  const isNonStop =
    Array.isArray(busRoute) &&
    busRoute.length > 0 &&
    !getTimelineStations(booking, busRoute).some(
      obj => obj?.station?.type === "RESTSTOP"
    );

  const isTripCompleted = tripStatus === "COMPLETED";
  const statusIcon = isTripCompleted
    ? COMPLETED_ICON
    : booking.isOnboarded
    ? BOARDED_ICON
    : NOT_BOARDED_ICON;
  const statusLabel = isTripCompleted
    ? "Completed"
    : booking.isOnboarded
    ? "Boarded"
    : "Not Boarded";

  const isMaxx = serviceTier === "MAXX";
  const isPlus = serviceTier === "PLUS";
  const isTiered = isMaxx || isPlus;

  const pnr =
    booking.rescheduledFromBookingCode && booking.connectingBookingCode
      ? booking.rescheduledFromBookingCode
      : booking.connectingBookingCode
      ? booking.connectingBookingCode
      : booking.bookingCode;

  const renderTierCard = () => (
    <div className={isMaxx ? styles.tierCardMaxx : styles.tierCardPlus}>
      <div className={styles.tierHeader}>
        <div className={styles.tierBadge}>
          {isMaxx ? (
            <img className={styles.maxxLogo} src={MAXX_LOGO} alt="MAXX" />
          ) : (
            <div className={styles.plusPill}>
              <span>Plus</span>
              <img src={PLUS_ICON} alt="" />
            </div>
          )}
          <span className={styles.tierWordmark}>
            {isMaxx ? "zingbus MAXX" : "zingbus plus"}
          </span>
        </div>
        <div className={styles.statusPill}>
          <img src={statusIcon} alt="" />
          <span>{statusLabel}</span>
        </div>
      </div>

      <div className={styles.journeyCard}>
        {isNonStop ? <span className={styles.nonStopTag}>Non Stop</span> : null}
        <div className={styles.journeyRow}>
          <div className={styles.journeyPoint}>
            <span className={styles.journeyTime}>
              {moment(booking.boardingPoint.time).format(dateFormat)}
            </span>
            <span className={styles.journeyCity}>
              {booking.boardingPoint.city}
            </span>
            <span className={styles.journeyDate}>
              {moment(booking.boardingPoint.time).format(tierDayFormat)}
            </span>
          </div>
          <img
            className={styles.journeyArrow}
            src={ARROW_FORWARD}
            alt="arrow-forward"
          />
          <div className={`${styles.journeyPoint} ${styles.journeyPointEnd}`}>
            <span className={styles.journeyTime}>
              {moment(booking.dropPoint.time).format(dateFormat)}
            </span>
            <span className={styles.journeyCity}>{booking.dropPoint.city}</span>
            <span className={styles.journeyDate}>
              {moment(booking.dropPoint.time).format(tierDayFormat)}
            </span>
          </div>
        </div>

        <div className={styles.journeyDivider} />

        <div className={styles.pnrRow}>
          <div className={styles.pnrInfo}>
            {booking?.trip?.service?.isElectric ? (
              <div className={styles.electricTag}>
                <img src={ELECTRIC_ICON} alt="" />
                <span>Electric</span>
              </div>
            ) : null}
            <span className={styles.pnrText}>PNR: {pnr}</span>
          </div>
          <div className={styles.otpBadge}>
            <span className={styles.otpTag}>OTP</span>
            <span className={styles.otpValue}>{booking.boardingOtp}</span>
          </div>
        </div>
      </div>
    </div>
  );

  if (isTiered) {
    return (
      <div>
        {renderTierCard()}
        {props.showModifyBooking ? (
          <div className={styles.tierActions}>
            <div
              className={styles.modify}
              onClick={() => {
                props.showEditModal(true);
              }}
            >
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/sefhelp/editBooking/edit.svg "
                alt="edit"
              />
              <span>Modify Booking</span>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      <Card loading={false}>
        <div className={styles.wrapper}>
          <div className={styles.stationNames}>
            <div>
              <span>{booking.boardingPoint.city}</span>
              <div>
                <span>
                  {" "}
                  {moment(booking.boardingPoint.time).format(dateFormat)}
                </span>
                <div className={styles.ellipse} />
                <span>
                  {moment(booking.boardingPoint.time).format(dayFormat)}
                </span>
              </div>
            </div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/arrow-forward.svg"
              alt="arrow-forward"
            />
            <div>
              <span>{booking.dropPoint.city}</span>
              <div>
                <span>{moment(booking.dropPoint.time).format(dayFormat)}</span>
                <div className={styles.ellipse} />
                <span>{moment(booking.dropPoint.time).format(dateFormat)}</span>
              </div>
            </div>
          </div>
          <div className={styles.dashed} />
          <div className={styles.pnrView}>
            <div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/ticket/ticket.svg"
                alt="ticket"
              />
              <div>
                <span>PNR</span>
                <span>
                  {booking.rescheduledFromBookingCode &&
                  booking.connectingBookingCode
                    ? booking.rescheduledFromBookingCode
                    : booking.connectingBookingCode
                    ? booking.connectingBookingCode
                    : booking.bookingCode}
                </span>
              </div>
            </div>
            <div>
              <span>OTP: {booking.boardingOtp}</span>
            </div>
          </div>
          <div
            style={{ display: !props.showModifyBooking ? "none  " : "" }}
            className={styles.modify}
            onClick={() => {
              props.showEditModal(true);
            }}
          >
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/sefhelp/editBooking/edit.svg "
              alt="edit"
            />
            <span>Modify Booking</span>
          </div>
          {/* <LoungePass
            booking={booking}
            isLoungePassAvailable={isLoungePassAvailable}
          /> */}
        </div>
      </Card>
    </div>
  );
};

export default TripDetails;
